import './hto-address-form.scss';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// components
import { Form, Field } from 'react-final-form';
import GoogleAutoComplete from '../../../GoogleAutoComplete/GoogleAutoComplete';
// actions
import { isMobile, required } from '../../../../utils/validation';
import { getNumericChars, composeValidators, getGeocodeDetails, getAddressFromPlaces } from '../../../../utils/helper';
import { getLocationServiceDetails, resetLocationServiceDetails } from '../../../../actionCreators/hto';
import { getPincodeData } from '../../../../actionCreators/address';
import { htoLeadApi } from '../../../../actionCreators/checkout';
import localStorageHelper from '../../../../utils/localStorageHelper';

const onChangePhone = (e, input) => input.onChange(getNumericChars(e.target.value));

let adressDetails = {};
const inputText = 'Search Nearby Location';

const mutators = {
    setFormattedAddress: (args, state, utils) => utils.changeValue(state, 'address', () => args[0])
};

function HTOAddressForm(props) {

    const setAdressDetails = (address, isGpsIconClicked) => {
        adressDetails = { ...adressDetails, ...address };
        if ((!adressDetails.state || !adressDetails.city) && address.postcode) {
            props.getPincodeData(address.postcode);
        }
        // If someone clicks on gps icons
        if (isGpsIconClicked) {
            document.getElementById('hto-address-form').dispatchEvent(new Event('submit', { cancelable: true }));
        }
        props.resetLocationServiceDetails(false);
    };

    const getLocationServiceDetails = values => {
        const { phone, address } = values;
        adressDetails.phone = phone;
        if (adressDetails.lat && adressDetails.lng && address === adressDetails.formattedAddress) {
            props.getLocationServiceDetails(adressDetails.lat, adressDetails.lng);
        } else {
            getGeocodeDetails({ address }).then(res => {
                const x = res.geometry.location.lat();
                const y = res.geometry.location.lng();
                props.getLocationServiceDetails(x, y);
                const address = getAddressFromPlaces(res);
                setAdressDetails(address);
            }, error => {
                props.resetLocationServiceDetails(true);
                console.log(error.message);
            });
        }
    };

    useEffect(() => {
        if (props.locationServiceDetails && props.active) {
            const address = { ...props.locationServiceDetails, ...adressDetails };
            // if (!address.bookNow) { address.bookNow = { estimatedTime: 10, enable: true }; }
            localStorageHelper.setItem('appointmentType', '');
            localStorageHelper.setItem('htoAddress', address);
            props.navTo('view-location');
            '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
            htoLeadApi({ step: '1', mobileNumber: adressDetails.phone, pincode: props.locationServiceDetails.bookLater.postcode });
            '#endif'; // eslint-disable-line
        }
    }, [props.locationServiceDetails]);

    return (
        <Form
            onSubmit={getLocationServiceDetails}
            mutators={mutators}
        >
            {({ handleSubmit, form, values }) => {
                if (typeof (values.address) === 'undefined') props.resetLocationServiceDetails(false);
                return (
                    <form id="hto-address-form" onSubmit={handleSubmit} className="hto-address-form">
                        <Field name="phone" validate={composeValidators(required, isMobile)}>
                            {({ input, meta }) => {
                                return (
                                    <div className="margin-b20 mr-b30">
                                        <div className="hto-phone">
                                            <span className="phone-prefix fsp15">(+91)</span>
                                            <input className="form-control" {...input} type="tel" onChange={e => onChangePhone(e, input)} autoComplete="off" maxLength="10" placeholder="Enter Mobile Number" />
                                        </div>
                                        <div className="text-color_brick_red fs10 fsp10">{meta.error && meta.touched ? meta.error : ''}</div>
                                    </div>
                                );
                            }}
                        </Field>
                        <GoogleAutoComplete name="address" fillInAddress={setAdressDetails} mutators={form.mutators} needLatLng customClass="hto-google-address" customInputClass="form-control" placeholder={inputText}>
                            <button type="submit" className="hto-submit">Go</button>
                        </GoogleAutoComplete>
                        {(typeof (values.address) !== 'undefined' && (typeof props.locationServiceDetails === 'undefined') || props.googleZeroResult) && <div className="text-color_brick_red fs10 fsp10 location-err">We do not service at the given location, please try another location</div>}
                        <p className="fsp12">{props.htoConfig.citiesAvailed}</p>
                    </form>
                );
            }}
        </Form>
    );
}

const mapStateToProps = state => ({
    locationServiceDetails: state.hto.locationServiceableDetails,
    htoConfig: state.hto.htoConfig,
    googleZeroResult: state.hto.googleZeroResult
});

const mapDispatchToProps = dispatch => ({
    getPincodeData: pincode => dispatch(getPincodeData(pincode)),
    getLocationServiceDetails: (lat, lng) => dispatch(getLocationServiceDetails(lat, lng)),
    htoLeadApi: data => dispatch(htoLeadApi(data)),
    resetLocationServiceDetails: flag => dispatch(resetLocationServiceDetails(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(HTOAddressForm);
